/** @format */

export enum ColorSwatchPriceOrder {
  ListPrice = 0,
  Markdown = 1,
  Clearance = 2,
}
